import axios from "axios";

const {REACT_APP_ADMIN_API} = process.env;

export const getDeviceTemplates = async (
  cancelToken,
) => {
  const region = localStorage.getItem("region");
  const url = `${REACT_APP_ADMIN_API}/api/fulltemplate?db=${region}&expand=0&results_per_page=10000`;
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "get",
      url,
      headers: { Authorization: `Bearer ${token}` },
      cancelToken,
    });
    return { data: response.data };
  } catch (e) {
    return { detail: e.response?.data?.error };
  }
};
